import { Labelled } from './generic';

export interface Tab<T> extends Labelled<T> {}

export enum PlayerDataLockerTabValue {
  GENERAL = 'general',
  PLAYER = 'player',
  METRICS = 'metrics',
}
